import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const AngeKlagomal = lazy(() => import("@/pages/info/AngeKlagomal"));

export const Route = createFileRoute("/anger-klagomal")({
  head: () => seoHead("/anger-klagomal", { description: "Vill du ångra ett avtal du tecknat via oss, eller är du missnöjd med något? Fyll i formuläret så hanterar vi ditt ärende skyndsamt." }),
  component: () => <AngeKlagomal />,
});
